export const ROLES = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  CUSTOMER: "Customer",
  BEAUTICIAN: "Beautician",
};

export const BOOKING_STATUS = {
  REQUESTED: "Requested",
  ASSIGNED: "Assigned",
  ACCEPTED: "Accepted",
  IN_PROGRESS: "InProgress",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  REJECTED: "Rejected",
};

export const BEAUTICIAN_SKILLS = [
  "Hair",
  "Makeup",
  "Facial",
  "Spa",
  "Nails",
  "Waxing",
  "Threading",
  "Bridal",
  "Mehendi",
  "Other",
];

export const VERIFICATION_STATUS = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const COMPLAINT_STATUS = {
  OPEN: "Open",
  IN_PROGRESS: "InProgress",
  RESOLVED: "Resolved",
  CLOSED: "Closed",
};

export const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
